import conf from '@/js/conf/conf'
import PullTo from 'vue-pull-to'
import emptyImage from '@/assets/empty.png'
import utils from '@/js/utils'
import service from '@/js/service'
export const mixins = {
  components: {
    PullTo
  },
  props: {
    view: {
      type: Object,
      default() {
        return {}
      }
    },
    state: {
      type: Object,
      default() {
        return {}
      }
    },
    db: {
      type: Object,
      default() {
        return {}
      }
    },
    file: {
      type: Object,
      default() {
        return {}
      }
    },
    mod: {
      type: String,
      default() {
        return 'new'
      }
    },
    params: {
      type: Object,
      default() {
        return {}
      }
    },
    thumbSize: {
      type: Number,
      default: 168
    },
    pageSize: {
      type: Number,
      default: 12
    },
    loginStatus: {
      type: Boolean,
      default: false
    },
    loginUserId: {
      type: Number,
      default: 0
    },
    subtractHeight: {
      type: Number,
      default: 0
    },
    isPop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const catalogs = conf.catalogs()
    const schema = {
      scrollTop: 0,
      // 瀑布流各列数据
      columns: [],
      items: [],
      horizWidth: 0,
      currentPage: 0,
      cursorValue: 0,
      cursorValueUp: 0,
      cursorValueDown: 0,
      cursorSkipUp: 0,
      cursorSkipDown: 0,
      skip: 0,
      noUpPage: false,
      noDownPage: false
    }
    let container_width, container_height
    if (this.state.platform.type === 'desktop' && this.isPop) {
      container_width = utils.popWidth()
      container_height = utils.popHeight()
    } else {
      container_width = utils.width()
      container_height = utils.height()
    }
    let horizThumbSize = 160
    if (this.state.platform.type !== 'mobile' && this.mod === 'index') {
      // 非移动端首页时，横向铺满
      horizThumbSize = Math.floor((utils.width() - (this.state.platform.type === 'desktop' ? 24 : 12) - (this.view.mainLeftSide ? this.view.mainLeftSideWidth : 0)) / this.pageSize - 10)
    }
    const data = {
      worksHost: conf.hosts().worksHost,
      container_width: container_width,
      container_height: container_height,
      width: container_width - 3,
      height: container_height - 95,
      // 水平局部时限制缩略图尺寸和水平宽度
      maxThumbWidth: horizThumbSize,
      maxThumbHeight: horizThumbSize,
      renew: false,
      fixHeight: 70,
      // 达到保留页数时，重新渲染列表
      remainPages: 100,
      showUp: false,
      userid: 0,
      albumid: 0,
      emptyImage: emptyImage,
      catalogs: catalogs,
      schema: schema,
      dt: {
        'new': utils.deepClone(schema),
        'hot': utils.deepClone(schema),
        'best': utils.deepClone(schema),
        'original': utils.deepClone(schema),
        'user': utils.deepClone(schema),
        'userPrivate': utils.deepClone(schema),
        'praise': utils.deepClone(schema),
        'favor': utils.deepClone(schema),
        'footprint': utils.deepClone(schema),
        'download': utils.deepClone(schema),
        'album': utils.deepClone(schema),
        'index': utils.deepClone(schema)
      },
      loading: {
        'new': false,
        'hot': false,
        'best': false,
        'original': false,
        'user': false,
        'userPrivate': false,
        'praise': false,
        'favor': false,
        'footprint': false,
        'download': false,
        'album': false,
        'index': false
      }
    }
    return data
  },
  computed: {
    isDesktop() {
      return this.state.platform.type === 'desktop'
    },
    isMobile() {
      return this.state.platform.type === 'mobile'
    },
    reqId() {
      return this.state.reqId
    },
    thumbWidth() {
      if (this.isMobile) {
        return this.thumbSize
      } else {
        return this.thumbSize * 1.5
      }
    },
    mainWidth() {
      if (this.isPop) {
        return this.width
      } else {
        return this.isDesktop && this.view.mainLeftSide ? this.width - this.view.mainLeftSideWidth : this.width
      }
    },
    maxColumns() {
      return Math.max(Math.floor(this.mainWidth / (this.thumbWidth + 10)), 1)
    },
    columnWidth() {
      return Math.round(this.mainWidth / this.maxColumns)
    },
    cardWidth() {
      return this.columnWidth - 10
    },
    // 瀑布流高度
    flowHeight() {
      let height = 0
      for (let i = 0; i < this.columns.length; i++) {
        const its = this.columns[i].items
        const colHeight = its[its.length - 1]._height + its[its.length - 1]._top
        if (colHeight > height) height = colHeight
      }
      return height
    },
    headHeight() {
      return (!this.isDesktop && this.config.showHead) ? 40 : 0
    },
    listStyle() {
      if (this.subtractHeight) return { 'height': 'calc(100% - ' + this.subtractHeight + 'px)', 'margin-top': '5px' }
      return { 'height': 'calc(100% - ' + (95 + this.headHeight) + 'px)', 'margin-top': (45 + this.headHeight) + 'px' }
    },
    config() {
      return this.view.works
    },
    users() {
      return this.state.users
    },
    data() {
      return this.dt[this.mod]
    },
    itemNums() {
      return this.data.items.length
    },
    columns() {
      return this.data ? this.data.columns : []
    },
    limit() {
      let limit = this.pageSize
      // 非首页及非移动端时分页数量X2
      if (!this.isMobile && this.mod !== 'index') limit = limit * 2
      return limit
    }
  },
  watch: {
    'view.mainLeftSide': {
      handler() {
        this.onResize()
      }
    },
    'view.praise.show': {
      handler() {
        if (this.view.praise.show && this.mod === 'praise' && this.view.praise.type === 'works') this.updateData()
      }
    },
    'view.praise.type': {
      handler() {
        if (this.view.praise.show && this.mod === 'praise' && this.view.praise.type === 'works') this.updateData(true)
      }
    },
    'view.favor.show': {
      handler() {
        if (this.view.favor.show && this.mod === 'favor' && this.view.favor.type === 'works') this.updateData()
      }
    },
    'view.favor.type': {
      handler() {
        if (this.view.favor.show && this.mod === 'favor' && this.view.favor.type === 'works') this.updateData(true)
      }
    },
    'view.footprint.show': {
      handler() {
        if (this.view.footprint.show && this.mod === 'footprint' && this.view.footprint.type === 'works') this.updateData()
      }
    },
    'view.footprint.type': {
      handler() {
        if (this.view.footprint.show && this.mod === 'footprint' && this.view.footprint.type === 'works') this.updateData(true)
      }
    },
    'view.index.show': {
      handler() {
        if (this.view.index.show && this.mod === 'index') this.updateData()
      }
    },
    'view.download.show': {
      handler() {
        if (this.view.download.show && this.mod === 'download' && this.view.download.type === 'works') this.updateData()
      }
    },
    'view.download.type': {
      handler() {
        if (this.view.download.show && this.mod === 'download' && this.view.download.type === 'works') this.updateData(true)
      }
    },
    'view.albumWorks.show': {
      handler() {
        if (this.view.albumWorks.show && this.mod === 'album' && this.view.albumWorks.albumid !== this.albumid) this.updateData()
      }
    },
    'view.user.show': {
      handler() {
        if (this.view.user.show && ((this.mod === 'user' && this.view.user.type === 'works') || (this.mod === 'userPrivate' && this.view.user.type === 'worksPrivate'))) {
          if ((this.view.user.userid && this.userid !== this.view.user.userid) || !this.itemNums) {
            if (this.userid !== this.view.user.userid) this.init()
            this.getData('down')
          }
          this.update()
        }
      }
    },
    'view.user.type': {
      handler() {
        if (this.view.user.show && ((this.mod === 'user' && this.view.user.type === 'works') || (this.mod === 'userPrivate' && this.view.user.type === 'worksPrivate'))) {
          if (!this.view.user.pop) this.emit('setLocationHash')
          if ((this.view.user.userid && this.userid !== this.view.user.userid) || !this.itemNums) {
            if (this.userid !== this.view.user.userid) this.init()
            this.getData('down')
          }
          this.update()
        }
      }
    },
    'view.works.show': {
      handler(show) {
        if (this.config.type === this.mod && show) {
          if (!this.itemNums) this.getData('down')
          this.update()
          this.deleteItems()
        }
      }
    },
    'view.works.classid': {
      handler() {
        this.init()
        if (this.config.type === this.mod && this.config.show) {
          if (!this.config.pop) this.emit('setLocationHash')
          if (!this.itemNums) this.getData('down')
        }
      }
    },
    'view.works.type': {
      handler() {
        if (this.config.type === this.mod && this.config.show) {
          if (!this.config.pop) this.emit('setLocationHash')
          this.deleteItems()
          if (!this.itemNums) this.getData('down')
        }
      }
    },
    'view.works.sort': {
      handler() {
        if (this.config.type === this.mod && this.config.show) {
          this.init()
          if (!this.config.pop) this.emit('setLocationHash')
          if (!this.itemNums) this.getData('down')
        }
      }
    },
    'view.works.sortType': {
      handler() {
        if (this.config.type === this.mod && this.config.show) {
          this.init()
          if (!this.config.pop) this.emit('setLocationHash')
          if (!this.itemNums) this.getData('down')
        }
      }
    },
    'view.works.catalogid': {
      handler() {
        if (this.config.type === this.mod && this.config.show) {
          this.init()
          if (!this.config.pop) this.emit('setLocationHash')
          if (!this.itemNums) this.getData('down')
        }
      }
    },
    'view.album.renew': {
      handler() {
        if (this.mod === 'hot' || this.mod === 'best' || this.mod === 'original' || this.mod === 'new') this.updateItems()
      }
    },
    'view.works.renew': {
      handler() {
        if (this.mod === 'hot' || this.mod === 'best' || this.mod === 'original' || this.mod === 'new') this.updateItems()
        if (this.view.works.renew && this.view.works.renew.toString().substr(0, 9) === 'renewView' && this.config.type === this.mod) {
          this.renewView()
        }
      }
    },
    'data.scrollTop': {
      handler() {
        if ((this.view.albumWorks.show && this.mod === 'album') || (this.view.user.show && ((this.mod === 'user' && this.view.user.type === 'works') || (this.mod === 'userPrivate' && this.view.user.type === 'worksPrivate')))) {
          this.emit('setScrollTop', [this.data.scrollTop])
        }
      }
    }
  },
  mounted() {
    this.calcSize()
    const container = this.scrollContainer()
    if (container) container.onscroll = () => { this.data.scrollTop = container.scrollTop }
    window.addEventListener('resize', this.onResize)
    if (this.config.show && !this.itemNums && this.mod !== 'user' && this.mod !== 'userPrivate') return this.getData('down')
  },
  methods: {
    // 更新数据
    updateItems() {
      for (var i in this.data.items) {
        const data = this.state.updateWork[this.data.items[i].workid]
        if (data) {
          for (const k in data) {
            this.data.items[i][k] = data[k]
          }
        }
      }
      this.renderItems(this.data.items, true)
    },
    // 逻辑删除作品
    deleteItems() {
      let deleteIds = []
      if (this.mod === 'hot') deleteIds = this.state.deleteHotWork
      if (this.mod === 'best') deleteIds = this.state.deleteBestWork
      if (this.mod === 'original') deleteIds = this.state.deleteOriginalWork
      if (this.mod === 'new') deleteIds = this.state.deleteWork
      const ids = []
      for (var id in deleteIds) {
        ids.push(parseInt(id))
      }
      if (ids.length) {
        const items = []
        for (var i in this.data.items) {
          if (ids.indexOf(this.data.items[i].workid) < 0) items.push(this.data.items[i])
        }
        this.data.items = items
        if (this.mod === 'hot') this.state.deleteHotWork = {}
        if (this.mod === 'best') this.state.deleteBestWork = {}
        if (this.mod === 'original') this.state.deleteOriginalWork = {}
        if (this.mod === 'new') this.state.deleteWork = {}
        this.renderItems(this.data.items, true)
      }
    },
    // 移除作品
    removeItem(id) {
      for (var i in this.data.items) {
        if (this.data.items[i].workid === id) {
          this.data.items.splice(i, 1)
        }
      }
      this.renderItems(this.data.items, true)
    },
    // 设置主题属性
    setItem(workid, key, value) {
      for (var i in this.data.items) {
        if (this.data.items[i].workid === workid) {
          this.data.items[i][key] = value
          return this.data.items[i]
        }
      }
    },
    scrollContainer() {
      const main = document.getElementById('works-' + this.mod + '-container')
      if (main) {
        const scroll = main.getElementsByClassName('scroll-container')
        if (scroll.length) return scroll[0]
      }
    },
    onResize() {
      if (!this.config.show && !this.view.user.show && !this.view.praise.show && !this.view.favor.show && !this.view.footprint.show && !this.view.index.show && !this.view.download.show && !this.view.albumWorks.show) return
      this.calcSize()
      // this.backTop()
      // this.data.scrollTop = 0
      this.renderItems(this.data.items, true)
    },
    backTop() {
      const container = this.scrollContainer()
      if (container) {
        setTimeout(() => {
          container.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
        }, 100)
      }
    },
    renewView() {
      this.backTop()
      this.loadData(() => {}, 'renew')
    },
    showItem(item) {
      if (item._top <= this.data.scrollTop - this.height && item._top + item._height >= this.data.scrollTop - this.height) return true
      if (item._top >= this.data.scrollTop - this.height && item._top <= this.data.scrollTop + this.height + this.height) return true
      return false
    },
    formateTime: utils.formateTime,
    formateNums: utils.formateNums,
    // 调用父组件方法
    emit(fn, params) {
      if (!fn) return
      this.$emit('receive', fn, params || [])
    },
    // 提示信息
    message(msg, type) {
      this.emit('message', [msg, type])
    },
    // 确认操作
    confirm(msg, fn, title) {
      this.emit('confirm', [msg, fn, title])
    },
    getMinHeight(arr) {
      const a = []
      for (let i = 0; i < arr.length; i++) {
        a.push(parseInt(arr[i]._height) + parseInt(arr[i]._top))
      }
      return Math.min.apply(null, a)
    },
    getMinIndex(val) {
      const arrIndex = []
      for (let i = 0; i < this.columns.length; i++) {
        const its = this.columns[i].items
        const height = its[its.length - 1]._height
        const top = its[its.length - 1]._top
        if (parseInt(height) + parseInt(top) === val) {
          arrIndex.push(i)
        }
      }
      return arrIndex
    },
    calcItemSize(w, h) {
      w = w || this.thumbSize
      h = h || this.thumbSize
      // 水平布局
      if (this.mod === 'index') {
        this.data.horizWidth = this.data.horizWidth + this.maxThumbWidth + 10
        return this.calcHorizItemSize(w, h)
      }
      let height = Math.round(this.cardWidth * h / w)
      height = Math.min(height, Math.round(this.height * 3 / 5))
      const width = Math.round(height * w / h)
      return { width: width, height: height }
    },
    // 计算水平布局的ItemSize
    calcHorizItemSize(w, h) {
      if (w < this.maxThumbWidth && h < this.maxThumbHeight) return { width: w, height: h }
      let width, height
      if (w > h) {
        width = this.maxThumbWidth
        height = Math.round(width * h / w)
      } else {
        height = this.maxThumbHeight
        width = Math.round(height * w / h)
      }
      return { width: width, height: height }
    },
    renderItems(items, refresh = false) {
      if (refresh) {
        this.data.columns = []
        this.data.horizWidth = 0
      }
      if (!items.length) return
      // 初始化列、列的第一个元素
      let idx = 0
      if (this.columns.length < this.maxColumns || refresh) {
        for (let i = 0; i < this.maxColumns; i++) {
          if (!this.columns[i] && items[idx]) {
            const itemSize = this.calcItemSize(items[idx].width, items[idx].height)
            items[idx]._top = 0
            items[idx]._raw_width = itemSize.width
            items[idx]._raw_height = itemSize.height
            items[idx]._height = items[idx]._raw_height + this.fixHeight
            this.columns.push({ items: [items[idx]] })
            idx++
          }
        }
      }
      // 对剩余元素的判断，应该放到哪一列
      for (var index = idx; index < items.length; index++) {
        // 找到高度最小的一列，可能有多个
        const tmp = []
        for (let i = 0; i < this.columns.length; i++) {
          const its = this.columns[i].items
          tmp.push({
            _height: its[its.length - 1]._height,
            _top: its[its.length - 1]._top
          })
        }
        // 获取最矮的列高度
        const minHeight = this.getMinHeight(tmp)
        // 获取最矮列的索引
        let minHeightIdx = 0
        const arrIndex = this.getMinIndex(minHeight)
        // 出现高度一样的，取索引最小的
        if (arrIndex.length > 0) {
          minHeightIdx = Math.min.apply(null, arrIndex)
        }
        // 设置属性
        const itemSize = this.calcItemSize(items[index].width, items[index].height)
        items[index]._top = minHeight
        items[index]._raw_width = itemSize.width
        items[index]._raw_height = itemSize.height
        items[index]._height = items[index]._raw_height + this.fixHeight
        this.columns[minHeightIdx].items.push(items[index])
      }
    },
    calcSize() {
      if (this.state.platform.type === 'desktop' && this.isPop) {
        this.container_width = utils.popWidth()
        this.container_height = utils.popHeight()
      } else {
        this.container_width = utils.width()
        this.container_height = utils.height()
      }
      this.width = this.container_width - 3
      this.height = this.container_height - 95 - this.headHeight
      let horizThumbSize = 160
      if (this.state.platform.type !== 'mobile' && this.mod === 'index') {
        // 非移动端首页时，横向铺满
        horizThumbSize = Math.floor((this.width - (this.state.platform.type === 'desktop' ? 24 : 12)) / this.pageSize - 10)
      }
      this.maxThumbWidth = horizThumbSize
      this.maxThumbHeight = horizThumbSize
    },
    init(backTop) {
      if (backTop) this.backTop()
      this.dt[this.mod] = utils.deepClone(this.schema)
    },
    update() {
      this.$forceUpdate()
    },
    updateData(updateHash) {
      if (updateHash && !this.config.pop) this.emit('setLocationHash')
      if (!this.itemNums) {
        this.init()
        this.getData('down')
      } else {
        this.update()
      }
    },
    getAvatar(item) {
      const ver = Math.round(new Date(this.users[item.userid].avatar_at) / 1000)
      if (this.users[item.userid] && this.users[item.userid].avatar) return service.getCosUrl(this.users[item.userid].avatar, 'avatar', ver) || ''
    },
    // 移除专辑作品
    removeAlbumWork(item) {
      const params = {}
      params.albumid = this.params.albumid
      params.workid = item.workid
      service.actionDelete('album_work', params, (dt, type) => {
        if (type === 'success') {
          this.emit('decTotal')
          this.removeItem(params.workid)
          this.view.album.renew = 'renewView_' + utils.time('time')
        } else {
          this.message(dt, type)
        }
      }, true)
    },
    showActionSheet(item) {
      let btn = ''
      if (this.mod === 'album' && this.params.albumid) {
        if ((this.params.userid && this.params.userid === this.loginUserId) || (this.loginUserId && this.loginUserId < 10000)) btn = { title: this.$t('i.remove'), cb: () => { this.removeAlbumWork(item) } }
      }
      this.emit('showActionSheet', [item.userid, 'work', item, (id, data, dt, type) => {
        if (type === 'success') {
          this.view.works.renew = utils.time('time')
          this.deleteItems()
          if ((this.mod === 'user' || this.mod === 'userPrivate' || this.mod === 'album') && (data.public === 0 || data.public === 1 || data.check === 0 || data.flag === 0 || data.flag === 1)) {
            this.emit('decTotal')
            this.removeItem(id)
          }
        }
      }, btn])
    },
    loadData(loaded, direction) {
      if (this.config.show || this.view.user.show || this.view.praise.show || this.view.favor.show || this.view.footprint.show || this.view.index.show || this.view.download.show || this.view.albumWorks.show) {
        this.renew = direction === 'renew'
        if (direction === 'renew') {
          direction = 'down'
          this.data.currentPage = 0
          this.data.cursorValue = 0
          this.data.cursorValueUp = 0
          this.data.cursorValueDown = 0
          this.data.cursorSkipUp = 0
          this.data.cursorSkipDown = 0
          this.data.skip = 0
          this.data.noUpPage = false
          this.data.noDownPage = false
        }
        this.getData(direction, () => {
          this.renew = false
          loaded('done')
        })
      }
    },
    openViewer(type, userid, workid) {
      const data = {
        userid: userid,
        workid: workid,
        publishid: 0
      }
      if (type === 1) {
        this.emit('openBrickyViewer', [{ data: data }])
      } else {
        this.emit('openWorkViewer', [{ data: data }])
      }
    },
    // 分页读取数据
    async getData(direction, cb) {
      direction = direction || 'down'
      if (!this.config.show && !this.view.user.show && !this.view.praise.show && !this.view.favor.show && !this.view.footprint.show && !this.view.index.show && !this.view.download.show && !this.view.albumWorks.show) return cb && cb()
      if (direction === 'up' && this.data.noUpPage) return cb && cb()
      if (direction === 'down' && this.data.noDownPage) return cb && cb()
      if (this.loading[this.mod]) return cb && cb()
      this.loading[this.mod] = true
      const params = {
        'sort_field': 'update_at',
        'sort': 'desc',
        'limit': this.limit,
        'skip': direction === 'up' ? this.data.cursorSkipUp : this.data.cursorSkipDown,
        'cursor_value': direction === 'up' ? this.data.cursorValueUp : this.data.cursorValueDown,
        'direction': direction
      }
      if (this.config.sortType === 'create') {
        params.sort_field = 'add_at'
      } else {
        params.sort_field = 'update_at'
      }
      if (this.config.sort === 'asc') {
        params.sort = 'asc'
      } else {
        params.sort = 'desc'
      }
      if (utils.empty(this.params.classid)) {
        if (utils.empty(this.config.classid)) {
          delete params.type
        } else {
          params.type = utils.getInt(this.config.classid)
        }
      } else {
        params.type = utils.getInt(this.params.classid)
      }
      // is_assets 0： 像素画 1： 素材（用户上传的）
      if (params.type === 2) {
        params.is_assets = 0
      }
      const catalogid = utils.getInt(this.config.catalogid)
      if (catalogid) params.catalogid = catalogid
      if (this.mod === 'hot') params.hot = 1
      if (this.mod === 'best' || this.mod === 'index') params.best = 1
      if (this.mod === 'original') params.original = 1
      if (this.mod === 'user' || this.mod === 'userPrivate') {
        this.userid = this.view.user.userid
        params.userid = this.view.user.userid
        if (this.mod === 'user') params.public = 1
        if (this.mod === 'userPrivate') params.public = 0
      }
      if (this.mod === 'praise' || this.mod === 'favor' || this.mod === 'footprint' || this.mod === 'download' || this.mod === 'album') {
        params.mod = this.mod
        if (this.mod === 'album') {
          this.albumid = this.view.albumWorks.albumid
          params.albumid = this.albumid
        }
      }
      // console.error('params', this.mod, params, direction, this.data.currentPage, this.data, direction === 'up', this.data.cursorValueUp, this.data.cursorValueDown)
      service.listGet('work', params, (res, type) => {
        if (type === 'success') {
          let refresh = false
          if (direction === 'up') {
            refresh = true
            this.data.cursorValueUp = res.data.cursor_value_up
            this.data.cursorSkipUp = res.data.cursor_skip_up
            if (!this.data.cursorValueDown && !utils.isEmpty(res.data.cursor_value_down)) this.data.cursorValueDown = res.data.cursor_value_down
            this.data.noUpPage = utils.isEmpty(this.data.cursorValueUp)
            this.data.items = res.data.items.concat(this.data.items)
          } else if (direction === 'down') {
            if ((res.data.count === this.limit && this.data.currentPage >= this.remainPages) || this.renew) {
              if (res.data.count === this.limit && this.data.currentPage >= this.remainPages) {
                this.init(true)
                this.showUp = true
              } else {
                this.init()
              }
              refresh = true
            }
            this.data.currentPage++
            if (!this.data.cursorValueUp && !utils.isEmpty(res.data.cursor_value_up)) this.data.cursorValueUp = res.data.cursor_value_up
            this.data.cursorValueDown = res.data.cursor_value_down
            this.data.cursorSkipDown = res.data.cursor_skip_down
            this.data.noDownPage = utils.isEmpty(this.data.cursorValueDown)
            this.data.items = this.data.items.concat(res.data.items)
          }
          if (res.data.users) {
            for (var userid in res.data.users) {
              this.users[userid] = res.data.users[userid]
            }
          }
          this.data.skip = utils.getInt(res.data.skip)
          if (this.mod === 'album') this.emit('setTotal', [res.data.total])
          this.getPraiseState(res.data)
          if (direction === 'up') {
            this.renderItems(this.data.items, true)
          } else {
            this.renderItems(res.data.items, refresh)
          }
        } else {
          this.message(res, type)
        }
        cb && cb()
        this.loading[this.mod] = false
        if (this.view.user.show) this.view.user.loading = false
        if (this.view.albumWorks.show) this.view.albumWorks.loading = false
        if (this.view.download.show) this.view.download.loading = false
        if (this.view.footprint.show) this.view.footprint.loading = false
        if (this.view.index.show) this.view.index.loading = false
        if (this.view.favor.show) this.view.favor.loading = false
        if (this.view.praise.show) this.view.praise.loading = false
      }, false, false)
    },
    // 喜欢
    praiseIt(workid) {
      if (!workid) return
      if (this.mod === 'praise' && this.state.praiseState[workid]) this.removeItem(workid)
      let praise_count = this.state.praiseCount[workid] || 0
      const praise = () => {
        if (this.state.praiseState[workid]) {
          this.state.praiseState[workid] = 0
          praise_count--
          service.decCount(this.loginUserId, 'work_praise')
        } else {
          this.state.praiseState[workid] = 1
          praise_count++
          service.incCount(this.loginUserId, 'work_praise')
        }
        praise_count = Math.max(0, praise_count)
        this.state.praiseCount[workid] = praise_count
        this.update()
      }
      praise()
      service.get('work_praise', workid, (dt, type) => {
        if (type !== 'success') {
          // 失败回滚
          praise()
          this.message(dt, type)
        }
      }, true)
    },
    // 取消收藏
    unfavorIt(workid) {
      if (!workid) return
      if (this.mod === 'favor') this.removeItem(workid)
      service.decCount(this.loginUserId, 'work_favor')
      service.get('work_favor', workid, '', true)
    },
    // 获取赞的状态
    getPraiseState(data) {
      if (!data) return
      if (data.praise) {
        for (var workid in data.praise) {
          this.state.praiseCount[workid] = data.praise[workid]
        }
      }
      const items = data.items
      if (Array.isArray(items)) {
        const ids = []
        for (var i in items) {
          if (data.praise[items[i].workid] && items[i].workid && typeof this.state.praiseState[items[i].workid] === 'undefined') {
            ids.push(items[i].workid)
          }
        }
        if (ids.length) {
          const params = { ids: ids, 'type': 'praise' }
          service.actionGet('work_count', params, (res, type) => {
            if (type === 'success' && res.data && res.data.praise) {
              for (const k in res.data.praise) {
                this.state.praiseState[k] = res.data.praise[k]
              }
              this.update()
            }
          }, true)
        }
      }
    }
  }
}
